import React, { useState } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from '../../ui/Table';
import Button from '../../ui/Button';

const HistoryLogRow = ({ log }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <Tr 
        className={`group cursor-pointer hover:bg-gray-50/50 transition-colors ${isExpanded ? 'bg-gray-50/50' : 'border-b border-gray-50 last:border-0'}`}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Td className="font-medium text-gray-900 w-48">{log.dateCreated ? new Date(log.dateCreated).toLocaleString('bg-BG') : '-'}</Td>
        <Td className="w-64">{log.email}</Td>
        <Td>
          <div className="font-medium text-gray-900">{log.action}</div>
        </Td>
      </Tr>
      
      {isExpanded && (
        <Tr className="border-b border-gray-100 bg-gray-50/30">
          <Td colSpan={3} className="p-0">
            <div className="p-6 overflow-hidden">
              <div className="text-[13px] bg-white p-4 rounded-xl border border-gray-100 space-y-4 font-mono break-all shadow-sm">
                {!log.objectBefore && !log.objectAfter ? (
                  <div className="text-gray-500 text-center py-2">Няма допълнителни данни към този запис.</div>
                ) : (
                  <>
                    {log.objectBefore && (
                      <div>
                        <span className="font-bold text-gray-900 block mb-2 font-sans uppercase tracking-wider text-[12px]">Преди (Стари данни):</span>
                        <div className="text-gray-600 bg-gray-50 p-3 rounded-lg border border-gray-100">
                          {log.objectBefore}
                        </div>
                      </div>
                    )}
                    {log.objectAfter && (
                      <div>
                        <span className="font-bold text-gray-900 block mb-2 font-sans uppercase tracking-wider text-[12px]">След (Нови данни):</span>
                        <div className="text-tenant-hover bg-tenant-light/50 p-3 rounded-lg border border-tenant-light/50">
                          {log.objectAfter}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </Td>
        </Tr>
      )}
    </>
  );
};

const HistoryLogTable = ({ logs = [], loadMore, hasMore }) => {
  return (
    <div className="px-6 pb-6">
      <div className="border border-gray-100 rounded-xl overflow-hidden mb-4">
        <Table>
          <Thead className="bg-white">
            <Tr className="border-b border-gray-100 hover:bg-transparent">
              <Th className="text-gray-900 text-[13px] capitalize w-48">Дата</Th>
              <Th className="text-gray-900 text-[13px] capitalize w-64">Имейл</Th>
              <Th className="text-gray-900 text-[13px] capitalize">Действие</Th>
            </Tr>
          </Thead>
          <Tbody>
            {logs.length === 0 ? (
              <Tr>
                <Td colSpan={3} className="text-center text-gray-500 py-8">Няма история</Td>
              </Tr>
            ) : (
              logs.map((log) => (
                <HistoryLogRow key={log.id} log={log} />
              ))
            )}
          </Tbody>
        </Table>
      </div>

      {hasMore && (
        <div className="px-4 py-6 flex justify-center border-t border-gray-100 mt-2">
          <Button onClick={loadMore} variant="primary" className="text-[13px] font-medium w-full sm:w-auto px-8 shadow-sm">
            Зареди още
          </Button>
        </div>
      )}
    </div>
  );
};

export default HistoryLogTable;
